import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=b3a0e9c8&scoped=true&"
import script from "./secondStep.vue?vue&type=script&lang=js&"
export * from "./secondStep.vue?vue&type=script&lang=js&"
import style0 from "./secondStep.vue?vue&type=style&index=0&id=b3a0e9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a0e9c8",
  null
  
)

export default component.exports